import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  ref: "menuButton",
  class: "toolbar-menu-item"
}

import useCustomIcon from '@/utilities/composables/useCustomIcon';
import TooltipTemplate from '@/components/elements/TooltipTemplate.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionItem',
  props: {
    effect: {},
    icon: {},
    tooltip: {},
    meta: {},
    parentProps: {},
    disabled: { type: Boolean },
    active: { type: Boolean },
    label: {}
  },
  setup(__props: any) {

const props = __props;

const { iconPath, getCustomIconStyle } = useCustomIcon();

return (_ctx: any,_cache: any) => {
  const _component_v_popover = _resolveComponent("v-popover")!

  return (_openBlock(), _createBlock(_component_v_popover, {
    placement: "top",
    "content-tag": "div",
    class: "flex",
    tag: "div",
    "on-show": () => !!props.tooltip && !_ctx.isMobile
  }, {
    content: _withCtx(({ state }) => [
      (state.isVisible)
        ? (_openBlock(), _createBlock(TooltipTemplate, {
            key: 0,
            "tooltip-text": props.tooltip,
            "tooltip-meta": props.meta
          }, null, 8, ["tooltip-text", "tooltip-meta"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("button", {
            class: _normalizeClass(["min-w-6", {
            'disabled-toolbar-option': props.disabled,
            'is-active': props.active,
          }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.effect && props.effect(...args)))
          }, [
            (props.icon)
              ? (_openBlock(), _createElementBlock("em", {
                  key: 0,
                  class: _normalizeClass(["custom-icons page-toolbar group-hover:bg-icon-hover", { 'ml-1': props.label }]),
                  style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)(props.icon)))
                }, null, 6))
              : _createCommentVNode("", true),
            _cache[1] || (_cache[1] = _createTextVNode()),
            (props.label)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["text-text-default ml-1 text-sm", { 'mr-1': props.label }])
                }, _toDisplayString(props.label), 3))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ], 512),
      _cache[2] || (_cache[2] = _createTextVNode())
    ]),
    _: 3
  }, 8, ["on-show"]))
}
}

})